<template>
  <main class="BMain">
    <div class="mainCreadcrumbs">
      Store / {{ allData?.moduleName }} / {{ allData?.goodsName }}
    </div>

    <section class="mainProduct">
      <div class="leftBox">
        <div class="imgs">
          <!-- src="https://www.greenvalleyintl.com/resource/firstPage/LiGrip_H300.png" -->
          <NuxtImg
            :src="allData?.mainFile?.fileUrl"
            :alt="allData?.goodsName"
            quality="70"
            loading="lazy"
          />
        </div>
      </div>

      <div class="rigthBox">
        <h3 class="title">{{ allData?.goodsName }}</h3>
        <p class="price">USD ${{ cartState?.goodsTotalPrice }}</p>
        <p class="desc">
          {{ allData?.remark }}
        </p>
        <div class="learnMore" @click="learnMore(allData?.learnMoreUrl)">
          Learn More About {{ allData?.goodsCode }}
          <i class="learMoreIcon" />
        </div>

        <section class="modulesBox">
          <!-- modules -->
          <h4 class="modulesBoxTitle" v-if="state.modules?.moduleName">
            {{ state.modules?.moduleName }}
          </h4>
          <div
            v-if="state.modules?.list && state.modules?.list.length > 0"
            v-for="(item, i) in state.modules?.list"
            :key="i"
            class="modules"
          >
            <div
              :class="['modeType', item?.data?.select ? 'active' : '']"
              @click="changeModeType(item)"
            >
              {{ item?.data?.moduleName }}
              <sup v-if="item?.data?.moduleLabel" style="font-size: 12px">{{
                item?.data?.moduleLabel
              }}</sup>
            </div>

            <!-- 只要有children子项的modules，才允许显示子项 -->
            <div
              class="optionsContainer"
              v-if="item.children.length > 0 && item?.data?.select"
            >
              <ModeOptional :list="item.children" @onChange="onOptionsChange" />
            </div>

            <div
              class="cluster-desc"
              v-if="
                allData?.goodsCode === 'LiDAR360MLS' &&
                item.children.length > 0 &&
                item?.data?.select
              "
            >
              <div class="cluster-title">Cluster Computing</div>
              <div class="cluster-line">Includes Master Node and Engine.</div>
              <div class="cluster-line">
                To purchase, please contact
                <a href="mailto:info@greenvalleyintl.com"
                  >info@greenvalleyintl.com</a
                >
              </div>
            </div>
          </div>

          <!-- AI Agent beta access 提示：所有商品详情页均显示 -->
          <div class="cluster-desc agent-desc">
            <div class="cluster-line">
              Contact us at
              <a href="mailto:info@greenvalleyintl.com"
                >info@greenvalleyintl.com</a
              >
              to request AI Agent beta access.
            </div>
          </div>

          <!-- plans -->
          <h4 class="modulesBoxTitle">
            <span> {{ allData?.plans?.data?.moduleName }}</span>
          </h4>
          <ModeBtnGroup v-model="state.planType" :list="state.planTypeList" />

          <Terms :list="allData?.sailsRemark" v-if="allData?.sailsRemark" />
        </section>
      </div>
    </section>
  </main>
</template>

<script setup>
import BAddCart from "./BAddCart.vue";
import ModeBtnGroup from "./ModeBtnGroup.vue";
import ModeOptional from "./ModeOptional.vue";
import Terms from "./Terms.vue";
import PlansPopUp from "../../PopUp/PlansPopUp.vue";
import { message } from "ant-design-vue";
import { useCartStore, useAuthStore } from "@/stores";
import { useCookies } from "@vueuse/integrations/useCookies";
const cookies = useCookies(["sails.sid"]);
const authStore = useAuthStore();

import Event from "@/stores";

const { cartState, setGoodsTotalPrice } = useCartStore();
const route = useRoute();
const router = useRouter();
logInfo("route.params", route.params);

const allData = inject("allData");
logInfo("--------------- BMain ---------------", allData);

// plans中价格最高的goodsId
const findHighestPriceGoodsId = (data) => {
  if (data && data.length > 0) {
    return data.reduce(
      (acc, item) => {
        if (!acc.item || item.data.price > acc.item.data.price) {
          return { ...acc, item };
        }
        return acc;
      },
      { item: null },
    ).item?.data?.goodsId;
  } else {
    return "";
  }
};
// plans中价格最低的goodsId
const findLowestPriceGoodsId = (data) => {
  if (data && data.length > 0) {
    return data.reduce(
      (acc, item) => {
        if (!acc.item || item.data.price < acc.item.data.price) {
          return { ...acc, item };
        }
        return acc;
      },
      { item: null },
    ).item.data.goodsId;
  } else {
    return "";
  }
};
// plans中月份数最低的goodsId
const findLowestMonthsGoodsId = (data) => {
  if (data && data.length > 0) {
    return data.reduce(
      (acc, item) => {
        if (!acc.item || item.data.month < acc.item.data.month) {
          return { ...acc, item };
        }
        return acc;
      },
      { item: null },
    ).item.data.goodsId;
  } else {
    return "";
  }
};

/**
 * 新版商品算价逻辑：
 *   有modules
 *       如果选择单独的模块，取选中模块的价格*选中plans的月份数
 *       如果选择有子项的模块，取子项目中选中的项价格之和*选中plans的月份数
 *   无modules
 *       取选中的plans价格
 */
const state = reactive({
  // modules
  modules: {
    moduleName: allData?.modules?.data?.moduleName || "",
    list: allData?.modules?.children || [],
  },

  // plans
  planType: "", // 选中的plans订阅类型id
  planTypeList: allData?.plans?.children || [], // plans订阅方式
  // planTypeDisableList: [],
  // tempDisableList: [],

  // 是否有modules
  hasModules:
    allData?.modules?.children && allData?.modules?.children.length > 0,
});
const isInitializingPlanType = ref(true);

const learnMore = (url) => {
  navigateTo(url, {
    open: {
      target: "_blank",
    },
  });
};

const changeModeType = (item) => {
  logInfo("changeModeType =>", item.data.moduleName);
  state.modules?.list.forEach((ele) => {
    ele.data.select = false;
  });
  item.data.select = true;

  // getTotalPrice();
  calcPrice();
};

// 子项的勾选事件
const onOptionsChange = () => {
  // getTotalPrice();
  calcPrice();
};

// 旧版 - 算价逻辑
const getTotalPrice = () => {
  /**
   * 新版商品算价逻辑：
   *   有modules
   *       如果选择单独的模块，取选中模块的价格*选中plans的月份数
   *       如果选择的是含有子项的模块，取子项中选中项的价格之和*选中plans的月份数
   *   无modules
   *       取选中的plans价格
   *
   */
  if (state.hasModules) {
    // 获取选中的模块
    const selectedModule = state.modules.list.find((item) => item.data.select);
    // 获取选中的plan
    const plan = state.planTypeList.find(
      (item) => item.data.goodsId === state.planType,
    );

    console.log("selectedModule :>> ", selectedModule);
    console.log("plan :>> ", plan);

    const month = plan?.data?.month;

    if (selectedModule) {
      if (selectedModule.data.hasSubItem) {
        // 有子项，取所有选中子项的价格之和
        const total = selectedModule.children.reduce((sum, child) => {
          if (child.data.select) {
            return sum + (child.data.price || 0);
          }
          return sum;
        }, 0);
        console.log("total :>> ", total);
        setGoodsTotalPrice(total * month);
      } else {
        // 没有子项，直接取当前模块价格
        setGoodsTotalPrice((selectedModule.data.price || 0) * month);
      }
    } else {
      setGoodsTotalPrice(0);
    }
  } else {
    // 无modules，直接取选中的plan价格
    const plan = state.planTypeList.find(
      (item) => item.data.goodsId === state.planType,
    );
    setGoodsTotalPrice(plan?.data?.price || 0);
  }
};

const addCart = async (res) => {
  console.log("------------ addCart ---------------");

  logInfo("data[addCart]", res);
  logInfo("state.planType[addCart]", state.planType);

  const params = {
    version: allData?.version,
    goods: [],
    // goods: [
    //   {
    //     id: state.planType,
    //     total: 1,
    //   },
    // ],
  };

  if (state.hasModules) {
    // 判断如果选中的modules为有子项的模块，判断是否至少存在一个子项被选中了
    const selectedModule = state.modules.list.find((item) => item.data.select);

    // 判断当前选中的modules是否有子项
    if (selectedModule && !selectedModule.data.hasSubItem) {
      // 不含子项，直接添加主模块
      params.goods.push({
        id: selectedModule.data.goodsId,
        total: 1,
        plansId: state.planType,
      });
    } else if (selectedModule && selectedModule.data.hasSubItem) {
      // 含有子项，取所有选中的子项
      const selectedChildren = selectedModule.children.filter(
        (child) => child.data.select,
      );
      if (selectedChildren.length === 0) {
        return message.warning("Please select at least one sub-module first!");
      }
      selectedChildren.forEach((child) => {
        params.goods.push({
          id: child.data.goodsId,
          total: 1,
          plansId: state.planType,
        });
      });
    }
  } else {
    params.goods.push({
      id: "",
      total: 1,
      plansId: state.planType,
    });
  }

  logInfo("params[addCart] =>", params);

  // return;

  const { data, pending, error, refresh } = await useFetch(
    constants.BASE_URL + api.cartAdd + `?sid=${cookies.get("sails.sid")}`,
    {
      method: "post",
      body: params,
    },
  );
  logInfo(`${constants.BASE_URL + api.cartAdd} 加购入参`, params);
  logInfo("error", error);
  if (error.value) {
    cookies.remove("sails.sid", { path: "/" });
    authStore.delUserInfo();
    return navigateTo("/login");
  } else {
    if (data?.value?.code === 200) {
      logInfo(
        `${constants.BASE_URL + api.cartAdd} 返回数据`,
        data?.value?.data,
      );
      navigateTo(`/product/${route.params.name}/add-success`);
    } else {
      return message.error(data?.value?.msg);
    }
  }
};

const calcPrice = async (res) => {
  console.log("------------ addCart ---------------");

  logInfo("data[addCart]", res);
  logInfo("state.planType[addCart]", state.planType);

  if (!state.planType) {
    setGoodsTotalPrice(0);
    logInfo("calcPrice skipped: empty planType");
    return;
  }

  const params = {
    version: allData?.version,
    goods: [],
    // goods: [
    //   {
    //     id: state.planType,
    //     total: 1,
    //   },
    // ],
  };

  if (state.hasModules) {
    // 判断如果选中的modules为有子项的模块，判断是否至少存在一个子项被选中了
    const selectedModule = state.modules.list.find((item) => item.data.select);

    // 判断当前选中的modules是否有子项
    if (selectedModule && !selectedModule.data.hasSubItem) {
      // 不含子项，直接添加主模块
      params.goods.push({
        id: selectedModule.data.goodsId,
        total: 1,
        plansId: state.planType,
      });
    } else if (selectedModule && selectedModule.data.hasSubItem) {
      // 含有子项，取所有选中的子项
      const selectedChildren = selectedModule.children.filter(
        (child) => child.data.select,
      );
      if (selectedChildren.length === 0) {
        // Pricing should stay silent here; submit-time validation belongs to addCart.
        setGoodsTotalPrice(0);
        logInfo("calcPrice skipped: no selected sub-modules");
        return;
      }
      selectedChildren.forEach((child) => {
        params.goods.push({
          id: child.data.goodsId,
          total: 1,
          plansId: state.planType,
        });
      });
    }
  } else {
    params.goods.push({
      id: "",
      total: 1,
      plansId: state.planType,
    });
  }

  logInfo("params[productPrice] =>", params);

  // return;
  await nextTick();
  const { data, pending, error, refresh } = await useFetch(
    constants.BASE_URL + api.productPrice + `?sid=${cookies.get("sails.sid")}`,
    {
      method: "post",
      body: params,
    },
  );
  logInfo(`${constants.BASE_URL + api.productPrice} 算价入参`, params);
  logInfo(`${constants.BASE_URL + api.productPrice} 算价返回`, data);
  // console.log("error", error);
  if (error?.value) {
    cookies.remove("sails.sid", { path: "/" });
    authStore.delUserInfo();
    return navigateTo("/login");
  } else {
    if (data?.value?.code === 200) {
      logInfo("calcPrice success", data?.value?.data);
      logInfo(
        `${constants.BASE_URL + api.productPrice} 返回数据`,
        data?.value?.data,
      );
      setGoodsTotalPrice(data?.value?.data);
      // navigateTo(`/product/${route.params.name}/add-success`);
    } else {
      return message.error(data?.value?.msg);
    }
  }
};

const initPlanTypeAndPrice = async () => {
  state.planType = state.planTypeList.find(
    (item) => item.data.select,
  )?.data.goodsId;

  console.log("state.hasModules [init] :>> ", state.hasModules);
  console.log("state.planType [init] :>> ", state.planType);

  if (!state.planType) {
    setGoodsTotalPrice(0);
    isInitializingPlanType.value = false;
    logInfo("initPlanTypeAndPrice skipped: no default selected plan");
    return;
  }

  await calcPrice("init");
  isInitializingPlanType.value = false;
};

onMounted(() => {
  Event.on("addCart", addCart);
  logInfo("onMounted[BMain]");
  return initPlanTypeAndPrice();
});

// 监听plans订阅方式的改变，重新计算总价
watch(
  () => state.planType,
  (newValue, oldValue) => {
    if (isInitializingPlanType.value || !newValue || newValue === oldValue) {
      return;
    }
    calcPrice();
  },
);

onUnmounted(() => {
  Event.off("addCart", addCart);
});
</script>

<style lang="less" scoped>
.BMain {
  padding-top: 26px;
  border-bottom: 1px solid #a0a0a0;

  .mainCreadcrumbs {
    .fcf(18,#fff);
    width: 1200px;
    margin: 0 auto;
  }

  .mainProduct {
    display: flex;
    flex-direction: row;
    margin-top: 26px;
    .leftBox {
      flex: 1;
      padding-bottom: 90px;
      .imgs {
        position: sticky;
        top: 60px;
        min-width: 550px;
        img {
          height: auto;
          width: 100%;
          border-radius: 20px;
        }
      }
    }

    .rigthBox {
      // border: 1px solid red;
      width: 570px;
      margin-left: 30px;

      h3.title {
        .fcf(48,#fff,600);
      }

      .price {
        .fcf(28,#B9B9BB,600);
        margin-top: 53px;
      }
      .desc {
        .fcf(16,#B9B9BB);
        .lh(28);
        margin-top: 18px;
      }
      .learnMore {
        .fcf(17,#0189be);
        cursor: pointer;
        margin-top: 12px;

        .learMoreIcon {
          display: inline-block;
          background-image: url("@/assets/imgs/product/more.png");
          background-repeat: no-repeat;
          background-size: 100%;
          .wh(10px,10px);
        }
      }

      .modulesBox {
        margin-top: 20px;

        .cluster-desc {
          max-width: 100%;
          text-align: left;
          padding: 16px 18px;
          border-radius: 10px;
          background: #444;
          border: 1px solid rgba(255, 255, 255, 0.08);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
          margin-top: 12px;
          margin-left: 20px;
        }

        // AI Agent 提示板块：与模块卡片、下方 Plans 同宽，不沿用 cluster-desc 的左缩进
        .cluster-desc.agent-desc {
          margin-left: 0;
        }

        .cluster-title {
          .fcf(20,#fff,600);
          margin-bottom: 6px;
        }

        .cluster-line {
          .fcf(14,#fff);
          .lh(22);

          a {
            color: #6fd2ff;
            text-decoration: none;
          }

          a:hover {
            text-decoration: underline;
          }
        }
        h4.modulesBoxTitle {
          .flex(row,space-between,center);

          .fcf(22,#fff,600);
          margin-top: 50px;
          margin-bottom: 20px;
          padding-right: 20px;

          i {
            display: inline-block;
            background-image: url("@/assets/imgs/product/tips.png");
            background-repeat: no-repeat;
            background-size: 100%;
            cursor: pointer;
            .wh(20px,20px);
          }
        }

        .modules {
          // border: 1px solid green;

          .modeType {
            height: 80px;
            .fcf(22,#fff,600);
            .lh(80);
            background: #444444;
            border-radius: 10px;
            text-align: left;
            cursor: pointer;
            padding: 0 18px;
            .one-line-ellipsis();
          }
          .modeType + .modeType {
            margin-top: 12px;
          }
          .active {
            position: relative;
            background-image: url("@/assets/imgs/product/highlight.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }

          .disable {
            background: #222222;
            border-radius: 10px;
            color: #888;
          }

          .optionsContainer {
            padding-left: 20px;
          }
        }

        .modules + .modules {
          margin-top: 12px;
        }
      }
    }
  }
}

.plansPopUpContent {
  p {
    .fcf(24,#fff);
    .lh(29);
    text-align: left;
  }
  .imgs {
    width: 100%;
    height: auto;
    margin-top: 20px;
  }
}

@media (max-width: 1024px) {
  .BMain {
    .mainCreadcrumbs {
      padding-left: 5vw;
    }

    .mainProduct {
      flex-direction: column;
      .leftBox {
        padding-bottom: 50px;
        .imgs {
          min-width: 0;
        }
      }
      .rigthBox {
        width: 90vw;
        margin: 0 5vw;

        h3.title {
          .fcf(30,#fff,600);
        }

        .price {
          .fcf(20,#B9B9BB,600);
        }
        .desc {
          .fcf(14,#B9B9BB);
          .lh(23);
        }
        .learnMore {
          .fcf(14,#0189be);
        }

        .modulesBox {
          .modules {
            .modeType {
              .fcf(14,#fff,600);
            }
          }
        }
      }
    }
  }
}
</style>
